import { __decorate, __param } from 'tslib';
import { Inject, ɵɵdefineInjectable, ɵɵinject, Injectable, EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DpDatePickerModule } from 'ng2-date-picker';

let UiCDatePickerService = class UiCDatePickerService {
    constructor(config) {
        this.config = config;
    }
};
UiCDatePickerService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: ['config',] }] }
];
UiCDatePickerService.ngInjectableDef = ɵɵdefineInjectable({ factory: function UiCDatePickerService_Factory() { return new UiCDatePickerService(ɵɵinject("config")); }, token: UiCDatePickerService, providedIn: "root" });
UiCDatePickerService = __decorate([
    Injectable({
        providedIn: 'root'
    }),
    __param(0, Inject('config'))
], UiCDatePickerService);

let UiCDatePickerComponent = class UiCDatePickerComponent {
    constructor(service) {
        this.service = service;
        this.dateSelected = new EventEmitter();
        this.date = new Date(Date.now());
        // checa o environment
        this.controlEnv = 'app';
    }
    ngOnInit() {
        this.initialConfig();
    }
    initialConfig() {
        if (this.service.config.environment !== undefined ||
            this.service.config.environment !== null) {
            this.controlEnv = this.service.config.environment;
        }
        this.datePickerConfig = {
            format: 'DD/MM/YYYY',
            min: this.dataMinima
        };
    }
    dateChanged(e) {
        this.dateSelected.emit(e.detail.value);
    }
    /**
     * quando seleciona uma data do calendario
     */
    calDaySelected() {
        this.dateSelected.emit(this.selectedDate);
    }
};
UiCDatePickerComponent.ctorParameters = () => [
    { type: UiCDatePickerService }
];
__decorate([
    Input()
], UiCDatePickerComponent.prototype, "inputValue", void 0);
__decorate([
    Input()
], UiCDatePickerComponent.prototype, "dataMinima", void 0);
__decorate([
    Output()
], UiCDatePickerComponent.prototype, "dateSelected", void 0);
UiCDatePickerComponent = __decorate([
    Component({
        selector: 'ui-c-date-picker',
        template: "<div [ngSwitch]=\"controlEnv\">\n\n  <!-- display mobile -->\n  <ion-item *ngSwitchCase=\"'app'\" lines=\"none\">\n    <ion-label>{{inputValue }}</ion-label>\n    <ion-datetime (ionChange)=\"dateChanged($event)\" \n      cancelText=\"cancelar\" doneText=\"confirmar\" displayFormat=\"DD/MM/YYYY\">\n    </ion-datetime>\n  \n  </ion-item>\n\n  <!-- display web -->\n  <div *ngSwitchCase=\"'web'\" class=\"cal-holder-position\">\n    <dp-date-picker \n    theme=\"dp-material\" \n    (onChange)=\"calDaySelected()\"\n    [placeholder]=\"inputValue\"\n    [(ngModel)]=\"selectedDate\" \n    [config]=\"datePickerConfig\"></dp-date-picker>\n  </div>\n\n</div>\n",
        styles: [""]
    })
], UiCDatePickerComponent);

var UiCDatePickerModule_1;
let UiCDatePickerModule = UiCDatePickerModule_1 = class UiCDatePickerModule {
    static forRoot(config) {
        return {
            ngModule: UiCDatePickerModule_1,
            providers: [
                UiCDatePickerService,
                {
                    provide: 'config',
                    useValue: config
                }
            ]
        };
    }
};
UiCDatePickerModule = UiCDatePickerModule_1 = __decorate([
    NgModule({
        declarations: [UiCDatePickerComponent],
        imports: [
            IonicModule,
            CommonModule,
            FormsModule,
            DpDatePickerModule
        ],
        providers: [UiCDatePickerService],
        exports: [UiCDatePickerComponent]
    })
], UiCDatePickerModule);

/*
 * Public API Surface of ui-c-date-picker
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UiCDatePickerComponent, UiCDatePickerModule, UiCDatePickerService };
//# sourceMappingURL=wlp-ui-c-date-picker.js.map
